import { OnboardingState } from '../../types/OnboardingState';
import { SupplierOnboardingRequestMessage } from '../../types/SupplierOnboardingRequestMessage';
import { AttachmentListFile } from '../common/Attachments/types/AttachmentListFile';
import { translate } from '../common/helpers/translate.helper';
import { OfferModel } from '../offer/model/OfferModel';

export const SUPPLIER_ONBOARDING_DOCUMENTS_FILE_ID = 'supplier-onboarding-documents';

// A supplier's onboarding is shared across all their offers in an enquiry, but its documents belong
// to the offer it was initiated on (onboarding.offerId) — not the supplier's other offers.
export const supplierOnboardingAttachmentFiles = (
    onboarding: SupplierOnboardingRequestMessage | undefined,
    offer: OfferModel
): AttachmentListFile[] => {
    const hasSharedDocuments =
        onboarding &&
        onboarding.offerId === offer.id &&
        (onboarding.state === OnboardingState.SUBMITTED || onboarding.state === OnboardingState.CANCELED) &&
        onboarding.supplierDocuments.some((document) => document.submitted);

    if (!hasSharedDocuments) {
        return [];
    }

    return [
        {
            id: SUPPLIER_ONBOARDING_DOCUMENTS_FILE_ID,
            fileName: translate('supplierOnboarding.attachment.fileName'),
            companyId: offer.supplierId,
            dateCreated: onboarding.dateUpdated ?? '',
            isSupplierOnboardingFile: true,
        },
    ];
};
